import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import { memo } from "react";

export function VehicleIcon(props) {
  return <DeliveryDiningOutlinedIcon color="primary" {...props} />;
}

export default memo(VehicleIcon);
